import { darken } from '@material-ui/core/styles';
import { useTheme } from '@emotion/react';
import { useIntl } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { RETURN_BACKGROUND_RED, SALE_BACKGROUND_GREEN } from '../../../const/color-const';
import TransactionsPaymentType from './TransactionsPaymentCell';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  typeCell: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1.5, 0, 1.5),
    borderRadius: theme.shape.borderRadius,
    fontWeight: theme.typography.fontWeightBold,
    height: '20px',
    color: props => (props.type === props.currentTypeTranslation ? 'green' : 'red'),
    background: props => getBackgroundColorForCellType(props.type, props.currentTypeTranslation, theme),
  },
}));

const getBackgroundColorForCellType = (type, currentTypeTranslation, theme) => {
  const isLightTheme = theme.palette.type === 'light';
  const backgroundColor = type === currentTypeTranslation ? SALE_BACKGROUND_GREEN : RETURN_BACKGROUND_RED;
  return isLightTheme ? backgroundColor : darken(backgroundColor, 0.9);
};

export const TransactionsTypeCell = ({ type }) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const currentTypeTranslation = formatMessage({ id: 'report.transaction.sale', defaultMessage: 'Sale' });
  const classes = useStyles({ type, currentTypeTranslation, theme });
  
  return (
    <div className={classes.typeCell}>
      {type}
    </div>
  );
};

TransactionsPaymentType.propTypes = {
  type: PropTypes.string,
};